import { BoxButton, ManagedFlexModal } from '@riac/design-system';
import { theme } from '@riac/design-system';
import { InputErrorContainer } from '@riac/design-system';
import { AccordionItemToggle, AccordionContainer } from '@riac/design-system';
import { TBidButtonPage } from 'src/components/PlaceBid/PlaceBid';
import styled from 'styled-components';
import { FlexModal } from '@riac/design-system';

interface IPlaceBidButton {
  page: TBidButtonPage;
}

export const PlaceBidButton = styled.div<IPlaceBidButton>`
  display: inline-block;
  margin: ${(props) => props.page === 'catalog' ? '1rem 5px' : '0 5px'};
  ${BoxButton} {
    width: max-content;
    line-height: ${(props) => props.page === 'catalog' ? 0 : 'normal'};
    font-size: ${(props) => props.page === 'catalog' ? '2rem' : '1.8rem'};
    padding: ${(props) => props.page === 'catalog' ? '16px' : '12px 10px'};
    text-transform: capitalize;

    ${(props) => props.theme.widescreen} {
      line-height: ${(props) => props.page === 'catalog' ? 0 : 'inherit'};
    }
    span {
      margin-left: 5px;
    }
  }
`;

export const BidPlus = styled.div`
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  margin-bottom: 15px;
`;

export const PlaceBidModal = styled(FlexModal)`
  ${InputErrorContainer} {
    color: rgba(255, 255, 255, 0.85);
    margin-bottom: 10px;
  }
  ${AccordionContainer} {
    padding-bottom: 5px;
    margin-bottom: 25px;
    & button,
    p,
    span {
      color: ${theme.black[0]};
      font-size: 1.8rem;
    }
    & ol {
      list-style: circle;
      padding-left: 25px;
    }
  }
  ${AccordionItemToggle} {
    color: ${(props) => props.theme.black[90]};
  }
  h5 {
    margin: 20px 0;
  }
`;

export const SecondaryP = styled.p`
  && {
    color: ${(props) => props.theme.black[60]};
    margin: 20px 0;
  }
`;
